import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { countdown } from '../lib/time';
import { useToast } from '../app/shell-context';
import { Notice } from '../ui/parts';
import { useBooking } from './BookingContext';

/**
 * Бронь живёт 15 минут. По истечении возвращаем на выбор времени с честным
 * сообщением: молча упасть на подтверждении — худшее, что тут можно сделать,
 * потому что слот к тому моменту уже вернулся в общую сетку.
 */
export function HoldTimer() {
  const { booking, patch } = useBooking();
  const navigate = useNavigate();
  const toast = useToast();
  const [left, setLeft] = useState(() => remaining(booking.holdExpiresAt));

  useEffect(() => {
    if (!booking.holdExpiresAt) return;
    const id = window.setInterval(() => setLeft(remaining(booking.holdExpiresAt)), 1000);
    return () => clearInterval(id);
  }, [booking.holdExpiresAt]);

  useEffect(() => {
    if (!booking.holdExpiresAt || left > 0) return;
    patch({ appointmentId: null, holdExpiresAt: null, startsAt: null });
    toast('Бронь истекла — выберите время заново');
    navigate('/calendar', { replace: true });
  }, [left, booking.holdExpiresAt]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!booking.holdExpiresAt) return null;

  return (
    <Notice kind={left < 3 * 60_000 ? 'warn' : 'calm'}>
      Время держится за вами ещё {countdown(left)}. Потом слот вернётся в общую сетку.
    </Notice>
  );
}

function remaining(expiresAt: number | null): number {
  return expiresAt ? Math.max(0, expiresAt - Date.now()) : 0;
}
